// extracted by mini-css-extract-plugin
export var hero = "k60IHclcPsgi3oGDY7PG";
export var root = "LCkl611n5lNgwkfaaKoH";
export var title1 = "iv5EdsOZEVLxJ5SM4vdC";
export var title2 = "pHg_3wKTmpAHLsSQ8Gxs";
export var title3 = "yN6H0kDttt7OH9PqHtJU";